import screen1 from '../../assets/screen1.svg';
import screen4 from '../../assets/im4.png';
import screen5 from '../../assets/im5.png';
import screen6 from '../../assets/im6.svg';
import screen7 from '../../assets/im7.svg';
import img2 from '../../assets/positive-negative.png';
import img8 from '../../assets/im8.svg';
import img9 from '../../assets/im9.svg';
import img10 from '../../assets/im10.svg';
import img11 from '../../assets/im11.svg';
import img12 from '../../assets/im12.png';
import img13 from '../../assets/im13.svg';
import img15 from '../../assets/im15.svg';
import img16 from '../../assets/im16.svg';
import img17 from '../../assets/im17.svg';
import img18 from '../../assets/im18.svg';
import img19 from '../../assets/im19.svg';
import img20 from '../../assets/im20.svg';
import img21 from '../../assets/im21.png';
import img22 from '../../assets/im22.svg';
import img23 from '../../assets/im23.svg';
import img24 from '../../assets/im24.svg';
import img25 from '../../assets/im25.svg';
import cakeFinal from '../../assets/cake-final.png';
import cipa1 from '../../assets/cipa1.svg';
import cipa3 from '../../assets/cipa3.svg';
import friendsCake from '../../assets/friends-cake.png';
import hero from '../../assets/lesson-cover.svg';
import img14 from '../../assets/screen18.svg';

export const fractionsTheme = {
  id: 'fractions',
  title: 'Дроби',
  description: 'Вивчаємо дроби з нуля',
  screens: [
    {
      id: 1,
      type: 'lesson-cover',
      navigation: {
        type: 'single-button',
        buttonText: 'Мерщій почнімо',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
      content: {
        title: {
          value: '<b>Урок 1</b>',
          fontSize: 'xl',
          textAlign: 'center'
        },
        text: {
          value: 'Знайомство з&nbsp;дробами',
          fontSize: 'xl',
          textAlign: 'center'
        },
        image: hero
      }
    },
    {
      id: 2,
      type: 'hero',
      navigation: {
        type: 'single-button',
        buttonText: 'Почати квест',
        buttonBgColor: 'linear-gradient(96deg, rgb(241, 244, 88) 24%, rgb(218, 218, 64) 89%)'
      },
      content: {
        title: {
          value: 'Привіт 👋 <br/>Я Ципа, твій друг і помічник у світі математики. Гайда зі мною в гру «Чесний поділ»! <br/>Навчимося ділити піцу та цукерки так, щоб усім було порівну, і ніхто не сказав: «Агов, так нечесно!»',
          fontSize: 'sm',
          textAlign: 'left'
        },
        image: screen1
      }
    },
    {
      id: 3,
      type: 'fraction-comics-intro',
      navigation: {
        type: 'single-button',
        buttonText: 'Допомогти Ципі',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      }
    },
    {
      id: 4,
      type: 'fraction-story',
      navigation: {
        type: 'single-button'
      },
      content: {
        question: {
            value: 'На скільки частин Ципа поділив торт?',
            fontSize: 'md',
            textAlign: 'center'
          },
        image: friendsCake,
        options: [
            { text: '3', correct: false },
            { text: '4', correct: false },
            { text: '5', correct: true },
            { text: '6', correct: false }
        ],
        feedback: {
            correct: 'Правильно!',
            incorrect: 'Порахуй ще раз! У тебе все вийде 😉'
        }  
      }
    },
    {
      id: 5,
      type: 'hero',
      navigation: {
        type: 'single-button',
        buttonText: 'Біжу далі',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
      content: {
        text: {
          value: 'Розігрілися, еге ж? <br/>Отож, далі — 1 рівень! Тицяй і мерщій уперед!',
          fontSize: 'lg',
          textAlign: 'center'
        },
        image: screen1
      }
    },
    {
      id: 6,
      type: 'fraction-comics-1',
      navigation: {
        type: 'single-button',
        buttonText: 'Продовжити',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
    },
    {
      id: 7,
      type: 'fraction-comics-2',
      navigation: {
        type: 'single-button',
        buttonText: 'Продовжити',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
    },
    {
      id: 8,
      type: 'fraction-comics-3',
      navigation: {
        type: 'single-button',
        buttonText: 'Продовжити',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
    },
    {
      id: 9,
      type: 'fraction-comics-4',
      navigation: {
        type: 'single-button',
        buttonText: 'Продовжити',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
    },
    
    {
      id: 10,
      type: 'hero',
      navigation: {
        type: 'single-button',
        buttonText: 'Біжу далі',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
      content: {
        text: {
          value: '<b>Ого!<br/>Та це супер круто!</b>',
          fontSize: 'lg',
          textAlign: 'center'
        },
        image: cipa1,
        imageStyles: {
          right: '25%',
          transform: 'translate(20%, 0%)'
        }
      }
    },

    {
      id: 11,
      type: 'quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      content: {
        question: {
          value: 'Хто з героїв з’їв більший шматок торта?',
          fontSize: 'md',
          textAlign: 'center'
        },
        images: [
          { 
            src: screen4, 
            linkedTo: 0
          },
          { 
            src: screen5, 
            linkedTo: 1
          }
        ],
        options: [
          { text: 'Ципа', correct: false },
          { text: 'Фішик', correct: true }
        ],
        feedback: {
          correct: 'Правильно!',
          incorrect: 'Ципа з’їв <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math>  торта — одну частину з п’яти. <br/> Фішик з’їв <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>2</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math> торта — дві частини з п’яти. <br/>Оскільки дві частини — більше, ніж одна, то <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>2</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math> > <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math> <br/>✅ Більший шматок з’їв Фішик.'
        }
      }
    },
    {
      id: 12,
      type: 'hero',
      navigation: {
        type: 'single-button',
        buttonText: 'Біжу далі',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
      content: {
        text: {
          value: 'Молодець! Тепер будуть складніші запитання. Вони впливатимуть на те, який торт ми отримаємо.',
          fontSize: 'md',
          textAlign: 'center'
        },
        image: screen1
      }
    },
    {
      id: 13,
      type: 'basic-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      score: 4,
      content: {
        question: {
          value: 'Що означає число <b style="color: #E95E2A;">2</b> у дробі  <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn style="color: #E95E2A;">2</mn></mrow><mrow><mn style="color: #F4B7EA;">5</mn></mrow></mfrac></math> ?',
          fontSize: 'lg',
          textAlign: 'center'
        },
        options: [
          { text: 'На скільки рівних частин розрізали', correct: false },
          { text: 'Скільки частин узяли', correct: true }
        ],
        feedback: {
          correct: 'Так тримати!<br/>У дробі <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>2</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math> число 2 — це чисельник. Він показує, скільки частин узяли.<br/>Отже, число 2 означає, що взяли дві частини з п’яти.',
          incorrect: 'Згадай: чисельник зверху показує, скільки частин узяли. Подивися на дріб <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>2</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math> — яке число вгорі?'
        },
      }
    },
    {
      id: 14,
      type: 'basic-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      score: 4,
      content: {
        question: {
          value: 'Що означає число <b style="color: #F4B7EA;">5</b> у дробі  <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn style="color: #E95E2A;">2</mn></mrow><mrow><mn style="color: #F4B7EA;">5</mn></mrow></mfrac></math> ?',
          fontSize: 'lg',
          textAlign: 'center'
        },
        options: [
          { text: 'На скільки рівних частин розрізали', correct: true },
          { text: 'Скільки частин узяли', correct: false }
        ],
        feedback: {
          correct: 'Так тримати! У дробі <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>2</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math> число 5 — це знаменник. Він показує, на скільки рівних частин поділили ціле.<br/>Отже, число 5 означає, що торт (або інше ціле) поділили на п’ять рівних частин.',
          incorrect: 'Згадай: знаменник унизу показує, на скільки рівних частин поділили ціле. <br/>Подивися на дріб <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>2</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math> — яке число внизу?'
        }
      }
    },
    {
      id: 15,
      type: 'hero',
      navigation: {
        type: 'single-button',
        buttonText: 'Біжу далі',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
      content: {
        text: {
          value: '<b>Коли ми ділимо ціле на частини, не кожен поділ є справедливим.</b>',
          fontSize: 'lg',
          textAlign: 'center'
        },
        image: img2,
        imageStyles: {
          maxWidth: '470px',
          right: '55%',
          transform: 'translate(50%, -10%)'

        }
      }
    },
    {
      id: 16,
      type: 'multiple-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      score: 10,
      content: {
        question: {
          value: 'Які фігури поділені <b>на рівні частини</b>? Обери всі правильні відповіді.',
          fontSize: 'md',
          textAlign: 'center'
        },
        columnDirection: true,
        images: [
          { 
            src: img8, 
            linkedTo: 0
          },
          { 
            src: img9, 
            linkedTo: 1
          },
          { 
            src: img10, 
            linkedTo: 2
          },
          { 
            src: img11, 
            linkedTo: 3
          }
        ],
        options: [
          { text: 'А', correct: false },
          { text: 'Б', correct: true },
          { text: 'В', correct: false },
          { text: 'Г', correct: true }
        ],
        feedback: {
          correct: 'Молодець 🎉 <br/>Фігура поділена на рівні частини, якщо всі частини:<ul><li>однакові за площею;</li><li>однакові за формою.</li></ul>',
          incorrect: 'Подумай: що означає «рівні частини»? <br/>Спробуй уявити, що кожну фігуру треба розрізати так, щоб усі шматочки були однакового розміру.'
        }
      },
    },
    {
      id: 17,
      type: 'quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      content: {
        question: {
          value: 'Як думаєш, чи можемо ми записати частину цілого дробом, якщо частини нерівні між собою?',
          fontSize: 'md',
          textAlign: 'center'
        },
        image: img12,
        options: [
          { text: 'Так', correct: false },
          { text: 'Ні', correct: true },
        ],
        feedback: {
          correct: '⭐ Звісно! Дріб — це про чесний поділ на рівні частини.',
          incorrect: 'Пам’ятаєш, що дріб — це рівні частини? А тепер подивися на піцу. Чи всі шматочки тут однакові? '
        }
      }
    },
    {
      id: 18,
      type: 'multiple-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      score: 10,
      content: {
        question: {
          value: 'У якому прямокутнику зафарбовано <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>3</mn></mrow></mfrac></math> <b>площі</b>? Обери всі правильні відповіді.',
          fontSize: 'md',
          textAlign: 'center'
        },
        columnDirection: true,
        images: [
          { 
            src: img13, 
            linkedTo: 0
          },
          { 
            src: img14, 
            linkedTo: 1
          },
          { 
            src: img15, 
            linkedTo: 2
          },
          { 
            src: img16, 
            linkedTo: 3
          }
        ],
        options: [
          { text: 'А', correct: true },
          { text: 'Б', correct: true },
          { text: 'В', correct: true },
          { text: 'Г', correct: false }
        ],
        feedback: {
          correct: '⭐ Так! Щоб отримати <span style="white-space: nowrap"><math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>3</mn></mrow></mfrac></math>,</span> потрібно поділити ціле на 3 рівні частини й узяти 1 частину.',
          incorrect: 'Щоб було <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>3</mn></mrow></mfrac></math>, прямокутник має бути поділений на 3 рівні частини, і зафарбована тільки 1 частина.'
        }
      }
    },
    {
      id: 19,
      type: 'multiple-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      score: 10,
      content: {
        question: {
          value: 'У якому прямокутнику зафарбовано <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>3</mn></mrow><mrow><mn>4</mn></mrow></mfrac></math> <b>площі</b>? Обери всі правильні відповіді.',
          fontSize: 'md',
          textAlign: 'center'
        },
        columnDirection: true,
        images: [
          { 
            src: img17, 
            linkedTo: 0
          },
          { 
            src: img18, 
            linkedTo: 1
          },
          { 
            src: img19, 
            linkedTo: 2
          },
          { 
            src: img20, 
            linkedTo: 3
          }
        ],
        options: [
          { text: 'А', correct: true },
          { text: 'Б', correct: true },
          { text: 'В', correct: true },
          { text: 'Г', correct: false }
        ],
        feedback: {
          correct: '⭐ Так! Щоб отримати <span style="white-space: nowrap"><math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>3</mn></mrow><mrow><mn>4</mn></mrow></mfrac></math>,</span> потрібно поділити ціле на 4 рівні частини й узяти 3 частини.',
          incorrect: 'Щоб було <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>3</mn></mrow><mrow><mn>4</mn></mrow></mfrac></math>, прямокутник має бути поділений на 4 рівні частини, і зафарбовані 3 частини.'
        }
      }
    },
    {
      id: 20,
      type: 'quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      content: {
        question: {
          value: 'Ципа хотів поділитися ще й смачним пирогом. Пиріг розрізали на 2 шматки.<br><br><b>Чи дорівнює кожен шматок пирога <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>2</mn></mrow></mfrac></math> ?</b> ',
          fontSize: 'sm',
          textAlign: 'center'
        },
        image: img21,
        options: [
          { text: 'Так', correct: false },
          { text: 'Ні', correct: true },
        ],
        feedback: {
          correct: '⭐ Так! <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>2</mn></mrow></mfrac></math> може бути лише тоді, коли пиріг ділять на 2 рівні частини.',
          incorrect: 'Щоб кожна частина дорівнювала <span style="white-space: nowrap"><math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>2</mn></mrow></mfrac></math>,</span> пиріг має бути поділений на 2 рівні частини. Спробуй ще! '
        }
      }
    },
    {
      id: 21,
      type: 'basic-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      score: 6,
      content: {
        question: {
          value: 'Чому не можна сказати, що кожен шматок пирога становить <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>2</mn></mrow></mfrac></math> ?',
          fontSize: 'lg',
          textAlign: 'center'
        },
        options: [
          { text: 'Бо частин не дві', correct: false },
          { text: 'Бо частини різні за розміром', correct: true }
        ],
        feedback: {
          correct: '⭐ Так, правильно! Не можна сказати, що це <span style="white-space: nowrap"><math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>2</mn></mrow></mfrac></math>,</span> бо шматочки пирога різні за розміром.',
          incorrect: 'Щоб кожен шматок пирога був <span style="white-space: nowrap"><math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>2</mn></mrow></mfrac></math>,</span> недостатньо просто розрізати пиріг на дві частини — вони мають бути однакові за розміром. А тут шматочки різні.'
        }
      }
    },
    {
      id: 22,
      type: 'hero',
      navigation: {
        type: 'single-button',
        buttonText: 'Біжу далі',
        buttonBgColor: '#F1F458'
      },
      content: {
        title: {
          value: '<b>Молодець! Гості будуть уже зовсім скоро, але в нас є ще трохи часу, щоб поліпшити торт.</b>',
          fontSize: 'md',
          textAlign: 'center'
        },
        image: screen1
      }
    },
    {
      id: 23,
      type: 'input-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
        buttonBgColor: '#F1F458'
      },
      score: 10,
      content: {
        question: {
          value: 'Запиши дробом, яка частина кола зафарбована рожевим кольором.',
          fontSize: 'lg',
          textAlign: 'center'
        },
        image: screen6,
        inputs: [
          {
            id: 'numerator',
            correctValue: '3',
          },
          {
            id: 'denominator',
            correctValue: '4',
          }
        ],

        keypad: {
          values: ['1','2','3','4','5','6','7','8','9', '0']
        },
        feedback: {
          correct: '⭐ Так, правильно! Коло поділене на 4 рівні частини, і зафарбовано 3. Тому дріб — <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>3</mn></mrow><mrow><mn>4</mn></mrow></mfrac></math>',
          incorrect: 'Спробуймо ще раз разом! Щоб записати дріб, спочатку порахуй, на скільки рівних частин поділили коло (це знаменник — він унизу). Потім поглянь, скільки частин зафарбовано (це чисельник — він угорі).'
        }
      }
    },
    {
      id: 24,
      type: 'range-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
      },
      score: 8,
      content: {
        question: {
          value: 'Якщо зафарбувати 6 із 8 частин, то який дріб отримаємо?',
          fontSize: 'md',
          textAlign: 'center',
        },
        image: screen7,
        options: [
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>8</mn></mrow></mfrac></math>', value: '1/8' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>6</mn></mrow></mfrac></math>', value: '1/6' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>2</mn></mrow><mrow><mn>8</mn></mrow></mfrac></math>', value: '2/8' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>6</mn></mrow><mrow><mn>8</mn></mrow></mfrac></math>', value: '6/8', correct: true },
        ],
        feedback: {
          correct: '⭐ Так, правильно! Зафарбовано 6 із 8 частин, тому отримуємо дріб <b><math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>6</mn></mrow><mrow><mn>8</mn></mrow></mfrac></math></b>.',
          incorrect: 'Щоб записати дріб, порахуй: усього 8 рівних частин (це знаменник — унизу), і зафарбовано з них 6 частин (це чисельник — угорі). Який має бути дріб?',
        },
      },
    },
    {
      id: 25,
      type: 'range-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
      },
      score: 8,
      content: {
        question: {
          value: 'Якщо зафарбувати 8 із 8 частин, то який дріб отримаємо?',
          fontSize: 'md',
          textAlign: 'center',
        },
        image: img22,
        options: [
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>6</mn></mrow></mfrac></math>', value: '1/6' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>8</mn></mrow><mrow><mn>8</mn></mrow></mfrac></math>', value: '8/8', correct: true },
        ],
        feedback: {
          correct: '⭐ Так, правильно! Зафарбовано 8 із 8 частин, тому отримуємо дріб <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>8</mn></mrow><mrow><mn>8</mn></mrow></mfrac></math> — це одне ціле.',
          incorrect: 'Згадаймо: якщо зафарбовано всі 8 із 8 частин, то чисельник дорівнює знаменнику. Який має бути дріб? ',
        },
      },
    },
    {
      id: 26,
      type: 'hero',
      navigation: {
        type: 'single-button',
        buttonText: 'Почати',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
      content: {
        title: {
          value: '<b>Ми майже готові! Тепер на нас чекає супергра, у якій ми зможемо досягти нового рівня торта.</b>',
          fontSize: 'md',
          textAlign: 'center'
        },
        image: cipa3,
        imageStyles: {
          left: '-100px',
          transform: 'translate(30%, 0%)'
        }
      }
    },
    {
      id: 27,
      type: 'new-level',
      navigation: {
        type: 'single-button',
        buttonText: 'Продовжити',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
      content: {
        title: {
          value: '<b>Вітаю тебе в СУПЕРГРІ!</b>',
          fontSize: 'lg',
          textAlign: 'center'
        },
        text: {
          value: '<br/>Тут будуть <b>3&nbsp;завдання</b> для справжніх математиків і математикинь. Якщо відповіси правильно — отримаємо СУПЕРТОРТ!',
          fontSize: 'md',
          textAlign: 'center'
        }
      }
    },
    {
      id: 28,
      type: 'range-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
      },
      score: 10,
      content: {
        question: {
          value: 'Намисто має <b>4 золоті</b> та <b>5 срібних</b> намистин. Яку частину всіх намистин становлять золоті?',
          fontSize: 'md',
          textAlign: 'center',
        },
        image: img23,
        options: [
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>4</mn></mrow><mrow><mn>9</mn></mrow></mfrac></math>', value: '4/9', correct: true },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>5</mn></mrow><mrow><mn>9</mn></mrow></mfrac></math>', value: '5/9' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>4</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math>', value: '4/5' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>5</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math>', value: '5/5' },
        ],
        feedback: {
          correct: '⭐ Так, правильно! Усього 9 намистин, з них 4 — золоті, тому дріб — <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>4</mn></mrow><mrow><mn>9</mn></mrow></mfrac></math>.',
          incorrect: 'Порахуй, скільки всього намистин: 4 золотих + 5 срібних = 9 (це знаменник — він унизу). Золотих намистин — 4 (це чисельник — він угорі). Спробуй ще раз! ',
        },
      },
    },
    {
      id: 29,
      type: 'range-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
      },
      score: 10,
      content: {
        question: {
          value: 'Яка частина комірок у шпаківні <b>вільна</b>?',
          fontSize: 'md',
          textAlign: 'center',
        },
        image: img24,
        options: [
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math>', value: '1/5' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>2</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math>', value: '2/5', correct: true },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>3</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math>', value: '3/5' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>5</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math>', value: '5/5' }
        ],
        feedback: {
          correct: '⭐ Так, правильно! У шпаківні всього 5 комірок, з них 2 вільні, тому частина вільних комірок — <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>2</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math>',
          incorrect: 'Щоб знайти, яка частина комірок вільна, порахуй: усього 5 комірок (це знаменник), зайняті 3, тому вільні 5 − 3 = 2. Тоді правильний дріб…',
        },
      },
    },
    {
      id: 30,
      type: 'range-quiz',
      navigation: {
        type: 'single-button',
        buttonText: 'Перевірити',
      },
      score: 10,
      content: {
        question: {
          value: 'У класі — <b>20 дітей</b>: 7 хлопчиків і 13 дівчаток. Яка частина хлопчиків у класі?',
          fontSize: 'md',
          textAlign: 'center',
        },
        image: img25,
        options: [
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>1</mn></mrow><mrow><mn>5</mn></mrow></mfrac></math>', value: '1/5' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>7</mn></mrow><mrow><mn>20</mn></mrow></mfrac></math>', value: '7/20', correct: true },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>13</mn></mrow><mrow><mn>20</mn></mrow></mfrac></math>', value: '13/20' },
          { label: '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>20</mn></mrow><mrow><mn>20</mn></mrow></mfrac></math>', value: '20/20' }
          
        ],
        feedback: {
          correct: '⭐ Так, правильно! У класі 20 дітей, з них 7 хлопчиків, тому частина хлопчиків — <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn>7</mn></mrow><mrow><mn>20</mn></mrow></mfrac></math>',
          incorrect: 'Щоб знайти частину хлопчиків у класі, потрібно взяти кількість хлопчиків 7 (це чисельник) і поділити на кількість усіх дітей 20 (це знаменник). Отже, який правильний дріб?',
        },
      },
    },
    // {
    //   id: 31,
    //   type: 'new-level',
    //   navigation: {
    //     type: 'single-button',
    //     buttonText: 'Продовжити',
    //     buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
    //   },
    //   content: {
    //     title: {
    //       value: '<b>Вітаю тебе!</b>',
    //       fontSize: 'lg',
    //       textAlign: 'center'
    //     },
    //     text: {
    //       value: 'Чудовий результат 🎉',
    //       fontSize: 'lg',
    //       textAlign: 'center'
    //     },
    //     levelInfo: {
    //       currentLevel: 2,
    //       levelImg: cake2,
    //       score: 40,
    //       scoreDisplay: '⭐⭐'
    //     }

    //   }
    // },
    {
      id: 31,
      type: 'final',
      navigation: {
        type: 'restart-button',
        buttonText: 'Пройти ще раз',
        buttonBgColor: 'linear-gradient(96deg,rgba(241, 244, 88, 1) 24%, rgba(218, 218, 64, 1) 89%)'
      },
      content: {
        score: 40,
        scoreDisplay: '★★☆☆☆',
        cakeImage: cakeFinal,
        background: {
          type: 'heroes',
        },
        title: {
          value: '40 балів',
          fontSize: 'xl'
        }
      }
    }

  ]
};